export default __webpack_public_path__ + "static/media/spectacular.a2a57c61.jpg";